import { render, staticRenderFns } from "./SalesTable.vue?vue&type=template&id=48aaf764"
import script from "./SalesTable.vue?vue&type=script&lang=ts"
export * from "./SalesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports